import { render, staticRenderFns } from "./Cola.vue?vue&type=template&id=1963d3c6"
import script from "./Cola.vue?vue&type=script&lang=js"
export * from "./Cola.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports